import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthorizeByVkMutation } from '../../../entities/vk/vkResource/redux/vkResource.api';
import { getAccount, getAppUsers } from '../../../shared/api/api';
// eslint-disable-next-line import/no-unresolved
import { AUTH_FIELDS, authActions } from '../../../entities/auth/tokenResource/redux/tokenResource';
import { useAppDispatch } from '../../../app/store';
import useAuth from '../../../shared/lib/hooks/useAuth';
import { vkRedirectGetMyTokenPage } from '../../../entities/baseQueryWithReAuth/baseQueryWithReAuth';

// функция после проверки токена
export const authorization = (token, dispatch, signin, navigate, setErrorText) => {
  // eslint-disable-next-line no-undef
  sessionStorage.setItem('isAuthVk', 'true');
  // eslint-disable-next-line no-undef
  localStorage.setItem('isAuthVk', 'true');
  // eslint-disable-next-line no-undef
  sessionStorage.setItem('token', token);
  // eslint-disable-next-line no-undef
  localStorage.setItem('token', token);

  dispatch(authActions.login({ [AUTH_FIELDS.TOKEN_ACCESS]: token }));

  getAccount()
    .then((user) => {
      if (user.login) {
        getAppUsers({ userId: user.id }).then((appUser) => {
          const currentUser = appUser[0];
          const userInfo = {
            appUserId: currentUser.appUserId,
            ...user,
          };
          let redirectUrl = '/companies';
          const visitVistarM = window.localStorage.getItem('visitVistarM');
          if (!visitVistarM) {
            redirectUrl = '/quick-start';
            window.localStorage.setItem('visitVistarM', true);
          }
          signin(userInfo, () => {
            window.location.replace(redirectUrl);
          });
        });
      }
      if (!token) setErrorText('Неправильный токен авторизации');
    })
    .catch(() => {
      setErrorText('Ошибка при авторизации аккаунта');
    });
};

export function parseVKPayloadFromURL(url) {
  const urlParams = new URLSearchParams(url.split('?')[1]);
  return {
    code: urlParams.get('code'),
    state: urlParams.get('state'),
    deviceId: urlParams.get('device_id'),
  };
}

function VkAuthPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { signin } = useAuth();

  const [authorizeByVK, { isError, isLoading, isSuccess, data }] = useAuthorizeByVkMutation();
  const [errorText, setErrorText] = useState('');

  useEffect(() => {
    const { code, state, deviceId } = parseVKPayloadFromURL(window.location.href);

    if (code) {
      authorizeByVK({ code, state, device_id: deviceId });
    } else {
      setErrorText('Параметр code не найден. Попробуйте авторизоваться снова.');
    }
  }, []);

  useEffect(() => {
    if (isError) {
      setErrorText('Авторизоваться через ВК не удалось, попробуйте:');
    }

    if (isSuccess) {
      authorization(data.id_token, dispatch, signin, navigate, setErrorText);
    }
  }, [isError, isSuccess, data]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <div>
        {errorText || (
          <>
            {isLoading ? 'Авторизация в системе.' : null}
            {!isLoading && <CircularProgress />}
          </>
        )}
        {errorText && (
          <div
            style={{
              width: 'max-content',
              margin: 'auto',
              paddingTop: '30px',
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                vkRedirectGetMyTokenPage(window.location.href, true);
              }}
            >
              Зарегистрироваться через ВК
            </Button>
            <Link
              style={{
                display: 'block',
                textAlign: 'center',
                marginTop: '30px',
              }}
              to="/"
            >
              <Button variant="contained">Перейти на авторизацию</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default VkAuthPage;
